export const trelloTemplate = {
    name: 'Trello Template',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        url: {
            name: 'URL',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    regexp: {
                        pattern: '^(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-/]))?$',
                        flags: null
                    }
                }
            ]
        },
        avatar: {
            name: 'Avatar',
            type: 'Link',
            linkType: 'Asset',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkMimetypeGroup: ['image'] }]
        },
        background: {
            name: 'Background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        attribution: {
            name: 'Attribution',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        description: {
            name: 'Description',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=trelloTemplate.js.map